<div class="auth-wrapper d-flex flex-column align-items-center justify-content-center min-vh-100 py-5">
    <div class="fixed-logo-top-left">
        <img src="assets/images/cim_ci_wt.png" alt="CrestInvolvement" height="35" class="d-inline-block">
    </div>

    <div class="login-card-container">
        <div class="login-card shadow d-flex flex-column flex-md-row overflow-hidden bg-white">

            <!-- Left Section: Brand & Notices (Image 1 & 2) -->
            <div class="card-left p-4 p-md-6 d-flex flex-column justify-content-between">
                <div class="brand-section">
                    <div class="d-flex align-items-center mb-1">
                        <div class="h1 font-weight-bold text-primary-dark mb-0 mr-2">META</div>
                    </div>
                    <div class="brand-subtitle h4 font-weight-bold mb-2">Total Car Care &<br />Safety Solution Provider
                    </div>
                    <div class="brand-description text-muted mb-4">
                        크레스트인볼브먼트의 차량 관제, 차량 진단 기술을 통한<br>Total Car Care & Safety Solution을 받아보세요.
                    </div>
                </div>

                <div class="notice-section p-4 text-white mt-4 mt-md-0">
                    <div class="d-flex align-items-center justify-content-between mb-3">
                        <h5 class="mb-0 text-white">공지사항</h5>
                        <button type="button" class="btn btn-sm btn-link text-white p-0 d-flex align-items-center"
                            (click)="clickNoticeListModal()">
                            <span class="mr-1">more</span>
                            <i class="fas fa-caret-right"></i>
                        </button>
                    </div>
                    <div class="notice-list-scroll">
                        <ul class="list-unstyled mb-0">
                            <ng-container *ngFor="let item of listNotice; let i=index;">
                                <li *ngIf="i<4"
                                    class="d-flex justify-content-between align-items-center py-1 pointer small"
                                    (click)="clickNoticeDetailModal(item)">
                                    <div class="text-truncate mr-2">{{item.title}}</div>
                                    <div class="text-nowrap opacity-75">{{item.updateDt | filterDateTime:'yyyy-MM-dd'}}
                                    </div>
                                </li>
                            </ng-container>
                            <li *ngIf="!listNotice || listNotice.length === 0"
                                class="small py-2 text-center opacity-75">
                                공지사항이 없습니다
                            </li>
                        </ul>
                    </div>
                </div>
            </div>

            <!-- Right Section: Login Form -->
            <div class="card-right p-4 p-md-6 border-left bg-light d-flex flex-column justify-content-center">
                <div class="login-header-title mb-5 text-center">
                    <h2 class="font-weight-bold text-dark">Admin Login</h2>
                </div>

                <form [formGroup]="formGroup" (ngSubmit)="onSubmit()" class="login-form">
                    <input type="hidden" formControlName="ipAccessDevice">
                    <div class="form-group mb-4">
                        <label class="small font-weight-bold text-dark mb-1">아이디</label>
                        <input type="text" class="form-control form-control-lg login-input" formControlName="userId"
                            placeholder="UserID" [ngClass]="{'is-invalid':submitted && f.userId.errors}" required
                            autofocus>
                        <div class="invalid-feedback" *ngIf="submitted && f.userId.errors">
                            <div *ngIf="f.userId.errors.required">필수 입력 항목 입니다</div>
                        </div>
                    </div>
                    <div class="form-group mb-4">
                        <label class="small font-weight-bold text-dark mb-1">패스워드</label>
                        <input type="password" class="form-control form-control-lg login-input" formControlName="userPw"
                            placeholder="Password" [ngClass]="{'is-invalid':submitted && f.userPw.errors}" required>
                        <div class="invalid-feedback" *ngIf="submitted && f.userPw.errors">
                            <div *ngIf="f.userPw.errors.required">필수 입력 항목 입니다</div>
                        </div>
                    </div>

                    <div class="alert alert-danger p-2 small mb-4" *ngIf="isSignInFail">
                        <i class="fas fa-exclamation-triangle fa-fw"></i>
                        <span class="ml-1" [innerHtml]="signInFailMessage"></span>
                    </div>

                    <button type="submit"
                        class="btn btn-primary btn-block btn-lg btn-login mb-3 font-weight-bold shadow-sm">
                        로그인
                    </button>

                    <div class="text-center">
                        <button type="button" class="btn btn-link btn-sm text-secondary px-0"
                            (click)="clickResetPasswordModal()">
                            비밀번호를 잊으셨나요?
                        </button>
                    </div>
                </form>
            </div>
        </div>

        <!-- Fixed Footer -->
        <footer class="footer-fixed py-4 mt-auto border-top bg-white w-100">
            <div class="container d-flex justify-content-center">
                <div class="d-flex align-items-start">
                    <!-- Left: Logo -->
                    <div class="mr-5 mt-1">
                        <icon-logo-crestinvolvement [bgColor]="'fill-secondary'" [borderColor]="''" [imgWidth]="''"
                            [imgHeight]="'35'" class="d-inline-block opacity-75"></icon-logo-crestinvolvement>
                    </div>

                    <!-- Right: All Text Content -->
                    <div class="text-left">
                        <!-- Links -->
                        <div class="d-flex flex-wrap align-items-center small text-secondary mb-2">
                            <a href="https://allgps.co.kr/" target="_blank" class="mr-3 text-secondary">회사소개</a>
                            <span class="text-muted opacity-50 mr-3">|</span>
                            <a href="javascript:void(0)" class="mr-3 text-secondary" (click)="clickEulaModal()">이용약관</a>
                            <span class="text-muted opacity-50 mr-3">|</span>
                            <a href="javascript:void(0)" class="mr-3 text-secondary"
                                (click)="clickPrivacyModal()">개인정보처리방침</a>
                            <span class="text-muted opacity-50 mr-3">|</span>
                            <a href="javascript:void(0)" class="mr-3 text-secondary"
                                [routerLink]="['/','fvms','install']">단말설치확인</a>
                            <div class="ml-1" [class.d-none]="envName === 'prod'">
                                <span class="badge badge-secondary px-2 py-1">{{envName}}</span>
                            </div>
                        </div>

                        <!-- Company Info -->
                        <div class="text-muted smaller mb-2">
                            <div class="mb-1">
                                <span>회사명 : (주)크레스트인볼브먼트</span>
                                <span class="mx-2">|</span>
                                <span>대표자명 : 박성준</span>
                                <span class="mx-2">|</span>
                                <span>본사 및 A/S 센터 : 서울특별시 성동구 성수이로 118 (성수동2가) 성수아카데미타워 205호(성수)</span>
                            </div>
                            <div class="mb-0">
                                <span>전화 : 1833-5697</span>
                                <span class="mx-2">|</span>
                                <span>통신판매업 신고 : 2020-서울성동-00404</span>
                            </div>
                        </div>

                        <!-- Copyright -->
                        <div class="text-muted smaller">
                            Copyright CRESTINVOLVEMENT All Rights Reserved.
                        </div>
                    </div>
                </div>
            </div>
        </footer>

    </div>